/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useRouter } from 'expo-router';
import { useMemo } from 'react';
import { ROUTES } from '../../constants/routes';
import { EmailLoginMode } from '../LoginView/types';

export interface VerifyEmailNavigationHandlers {
  onSignInWithPassword: () => void;
  onSignInWithPhoneNumber: () => void;
  onSignInWithPasskey: () => void;
  onSignUpWithDiffEmail: () => void;
}

export const useVerifyEmailNavigationDefaults = (
  email?: string,
): VerifyEmailNavigationHandlers => {
  const router = useRouter();

  return useMemo(() => {
    return {
      onSignInWithPassword: () =>
        router.push({
          pathname: ROUTES.ACCOUNT_LOGIN,
          params: {
            emailLoginMode: EmailLoginMode.PASSWORD,
            prefilledEmail: email,
            stacked: 'true',
          },
        }),
      onSignInWithPhoneNumber: () =>
        router.push({
          pathname: ROUTES.ACCOUNT_LOGIN,
          params: {
            loginMethod: 'mobile',
            stacked: 'true',
          },
        }),
      onSignInWithPasskey: () =>
        router.push({
          pathname: ROUTES.ACCOUNT_LOGIN,
          params: {
            autoPasskey: 'true',
            stacked: 'true',
          },
        }),
      onSignUpWithDiffEmail: () =>
        router.dismissTo({
          pathname: ROUTES.ACCOUNT_SIGN_UP,
        }),
    };
  }, [email, router]);
};
